module.exports = __webpack_public_path__ + "ru-icon.png?15643dbed1c4f8b5706d2cc227df6e0b";